import { transformAll, transformGroups, transformLocations } from './transform';
import schema from './schema';
import table from './table';
import fields from './fields';

const name = 'privilegesList';
const path = 'users/privileges_user';

export default {
  title: 'Privileges',
  get: {
    name,
    path: path,
    transform: transformAll,
    defaultValue: []
  },
  getGroups: { method: 'get', path: 'users/grouped_by_group', transform: transformGroups },
  getLocations: {
    path: 'branches',
    transform: transformLocations,
    defaultValue: []
  },
  table
};
